import { render, staticRenderFns } from "./records.vue?vue&type=template&id=7a808e49&scoped=true"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a808e49",
  null
  
)

export default component.exports